<template>
  <div>
    <lte-table
      :hdBackground="hdBackground"
      :data="gridBatchJobHistoryList"
      :columns="gridColumns"
      search_filter="left-search"
      :useCheckBox="useCheckBox"
      @selectedItems="selectedItems"
      :useFilter="useFilter"
      :boxStyle="boxStyle"
    ></lte-table>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
       <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from "@/lib/utils";
import i18n from "../../lang";

export default {
  name: "BatchJobHistory",
  data() {
    return {
      gridBatchJobHistoryList: [],
      actions: ["common.modify"], // "common.modify", "common.delete", common.printPdf
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "batch_job_history.batch_job_name", isHidden: true },
        { text: "batch_job_history.user_created", isHidden: true },
        { text: "batch_job_history.date_created", isHidden: true },
        { text: "batch_job_history.run_date", isHidden: true },
      ],
      boxStyle: false,
      useFilter: false,
      paginatorItem: {
        commit_function: "GET_BATCH_JOB_HISTORY_DATA"
      },

      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      isLoading: false,

      columnsReceipt: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },

      useCheckBox: false,
      used_wallet: false,
       isModalVisible: false,
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
    };
  },
  watch: {
    GET_BATCH_JOB_HISTORY_DATA: function() {
      this.gridBatchJobHistoryList=[]
      this.GET_BATCH_JOB_HISTORY_DATA.forEach((batchJob, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;

        let date_created = batchJob.date_created;
        let run_date = batchJob.run_date;
        let id = batchJob.id;
        let user = batchJob.profile.username;
        let batch_job_name = batchJob.profile.job_name
        let data = {
          "common.nonumber": nonumber,
          "batch_job_history.batch_job_name" : batch_job_name,
          "batch_job_history.user_created" : user,
          "batch_job_history.date_created": utils.formatSqlDate(date_created, null, "DD/MM/YYYY hh:mm:ss", ""),
          "batch_job_history.run_date": utils.formatSqlDate(run_date, null, "DD/MM/YYYY hh:mm:ss", ""),
          id: id
        };
        this.gridBatchJobHistoryList.push(data);
      });

      return this.gridBatchJobHistoryList;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsReceipt.data_list = this.gridColumns;
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_RECEIPT_DATA",
      "GET_BATCH_JOB_HISTORY_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ])
  },
  methods: {
    onBatchJobHistory: function () {
      const data = {
        params: {
          page: 1
        }
      };
      this.GET_BATCH_JOB_HISTORY(data);
    },
    getFullNameUserCreate(firstname, lastname){
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    getFullNameUserUpdate(firstname, lastname){
      return utils.getFullName(firstname, lastname, i18n.locale);
    },

 
    selectedItems: function(list_receipt_id) {
      // this.list_receipt_id = list_receipt_id;
    },

    getFullNameByLanguage(first_name, last_name) {
      if (data != null) {
        return utils.getFullName(first_name, last_name, i18n.locale);
      }
      return "";
    },
    onSearchReceipt: function(fromDate, toDate, userCreated) {
      const data = {
        params: {
          page: 1,
          from_date: fromDate,
          to_date: toDate,
          user_created: userCreated
        }
      };
      this.isLoading = true;
      this.GET_BATCH_JOB_HISTORY(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
 
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    addNew: function() {

    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_RECEIPT(this.originalRecordData)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.gridCustomerDataList.length == 1
                ? totalPage - 1
                : currentPage;
            const data = {
              params: {
                page: page
              }
            };
            this.GET_BATCH_JOB_HISTORY(data);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_BATCH_JOB_HISTORY"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_BATCH_JOB_HISTORY"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.GET_BATCH_JOB_HISTORY(data);
    },
    closeModal() {
      this.isModalVisible = false;
    },

    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_BATCH_JOB_HISTORY",
      "DELETE_RECEIPT",
      // "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG"
    ])
  },
  mounted() {
    this.columnsReceipt.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "receiptlist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
  },

  components: {
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    paginator: Paginator,
    loading: Loading,
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Project/BatchJobhistory.vue